import "core-js/modules/es.array.push.js";
import { CdrButton as x, CdrImg as v, CdrGrid as M } from "@rei/cedar";
import { resolveComponent as m, openBlock as o, createElementBlock as n, normalizeStyle as f, normalizeClass as d, createVNode as _, withCtx as h, Fragment as S, renderList as B, createElementVNode as C, mergeProps as O, createCommentVNode as l, createBlock as T, createTextVNode as V, toDisplayString as q } from "vue";
const I = (e, r) => {
  const t = e.__vccOpts || e;
  for (const [a, c] of r)
    t[a] = c;
  return t;
}, L = {
  /* c8 ignore start */
  name: "SimpleTopCategories",
  components: {
    CdrButton: x,
    CdrImg: v,
    CdrGrid: M
  },
  props: {
    categories: {
      type: Array,
      required: !0,
      default: () => []
    },
    grid: {
      type: String,
      required: !1,
      default: void 0
    },
    body: {
      type: String,
      required: !1,
      default: ""
    },
    cta: {
      type: Object,
      required: !1,
      default() {
        return {};
      }
    },
    footerAlignment: {
      type: String,
      required: !1,
      default: ""
    },
    imageRatio: {
      type: Object,
      required: !1,
      default() {
        return {};
      }
    },
    mediaConfig: {
      type: Object,
      require: !1,
      default() {
        return {};
      }
    }
  },
  computed: {
    renderComponent() {
      return this.categories.length || this.renderCta;
    },
    numberOfColumns() {
      return this.grid ? `repeat(${this.grid}, 1fr)` : this.categories.length === 2 ? "repeat(2, 1fr)" : this.categories.length % 4 === 0 ? "repeat(4, 1fr)" : "repeat(3, 1fr)";
    },
    cssVars() {
      var e, r, t, a;
      return {
        "--template-columns-mobile": this.grid && parseInt(this.grid, 10) % 2 !== 0 ? "repeat(3, 1fr)" : "repeat(2, 1fr)",
        "--template-columns-desktop": this.numberOfColumns,
        "--media-padding-mobile": ((r = (e = this.computedMediaConfig) == null ? void 0 : e.padding) == null ? void 0 : r.mobile) || 0,
        "--media-padding-desktop": ((a = (t = this.computedMediaConfig) == null ? void 0 : t.padding) == null ? void 0 : a.desktop) || 0
      };
    },
    renderCta() {
      var e, r;
      return !!((e = this.cta) != null && e.target && ((r = this.cta) != null && r.text));
    },
    computedMediaConfig() {
      return {
        ...{
          ratio: "4/3",
          fit: "contain",
          hasBackground: !0,
          padding: {
            mobile: "1.2rem",
            desktop: "1.2rem"
          }
        },
        ...this.mediaConfig
      };
    },
    wrapperClasses() {
      return ["simple-top-categories", this.computedMediaConfig.hasBackground ? "simple-top-categories--has-background" : ""];
    },
    footerClass() {
      return `
        simple-top-categories__footer ${this.footerAlignment === "right" ? "simple-top-categories__footer--right" : ""}
      `;
    },
    imageCssVar() {
      var e, r, t, a;
      return {
        "--image-padding-bottom-xs": ((e = this.imageRatio) == null ? void 0 : e.xs) || "100%",
        "--image-padding-bottom-sm": ((r = this.imageRatio) == null ? void 0 : r.sm) || "75%",
        "--image-padding-bottom-md": ((t = this.imageRatio) == null ? void 0 : t.md) || "75%",
        "--image-padding-bottom-lg": ((a = this.imageRatio) == null ? void 0 : a.lg) || "75%"
      };
    },
    renderFooter() {
      var e;
      return !!((e = this.cta) != null && e.target || this.body);
    }
  },
  methods: {
    getImgConfig(e) {
      var r, t;
      return {
        src: (r = e == null ? void 0 : e.media) == null ? void 0 : r.src,
        alt: ((t = e == null ? void 0 : e.media) == null ? void 0 : t.alt) || "",
        ratio: this.computedMediaConfig.ratio,
        fit: this.computedMediaConfig.fit,
        loading: "lazy"
      };
    },
    getContainerImageClass(e) {
      var t;
      return `simple-top-categories__media-container ${!!((t = e.customClass) != null && t.match("full-bleed")) ? "simple-top-categories__media-container--full-bleed" : ""}`;
    },
    getCategoryStyle(e = "") {
      const r = "simple-top-categories__category", t = [r];
      return e === "sale" && t.push(`${r}--sale`), t;
    }
  }
  /* c8 ignore end */
}, R = ["data-location-index"], A = ["href", "innerHTML"], H = ["innerHTML"];
function N(e, r, t, a, c, i) {
  const b = m("cdr-img"), k = m("cdr-grid"), y = m("cdr-button");
  return i.renderComponent ? (o(), n("div", {
    key: 0,
    style: f(i.cssVars),
    class: d(i.wrapperClasses)
  }, [_(k, {
    class: "simple-top-categories__grid",
    tag: "ul"
  }, {
    default: h(() => [(o(!0), n(S, null, B(t.categories, (s, g) => {
      var u, p;
      return o(), n("li", {
        key: s.key + "-" + g,
        class: d(i.getCategoryStyle(s.style)),
        style: f(i.imageCssVar),
        "data-location-index": g + 1
      }, [C("a", {
        href: (u = s.link) == null ? void 0 : u.href,
        class: "simple-top-categories__link",
        innerHTML: (p = s.link) == null ? void 0 : p.title
      }, null, 8, A), C("div", {
        class: d(i.getContainerImageClass(s))
      }, [_(b, O({
        ref_for: !0
      }, i.getImgConfig(s)), null, 16)], 2)], 14, R);
    }), 128))]),
    _: 1
  }), i.renderFooter ? (o(), n("div", {
    key: 0,
    class: d(i.footerClass)
  }, [t.body ? (o(), n("p", {
    key: 0,
    class: "simple-top-categories__body",
    innerHTML: t.body
  }, null, 8, H)) : l("", !0), i.renderCta ? (o(), T(y, {
    key: 1,
    href: t.cta.target,
    modifier: t.cta.theme,
    class: "simple-top-categories__cta",
    tag: "a"
  }, {
    default: h(() => [V(q(t.cta.text), 1)]),
    _: 1
  }, 8, ["href", "modifier"])) : l("", !0)], 2)) : l("", !0)], 6)) : l("", !0);
}
const F = /* @__PURE__ */ I(L, [["render", N]]);
export {
  F as default
};
